/* PD26 — fiche produit : galerie, zoom, options, quantité, ajout au panier, ampoules, barre collante. */
(function () {
  'use strict';
  var racine = document.querySelector('[data-pf]');
  if (!racine) return;
  var $ = function (s, c) { return (c || racine).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || racine).querySelectorAll(s)); };
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Galerie */
  var piste = $('[data-pf-piste]');
  var photos = piste ? $$('.p26-pf-galerie__photo', piste) : [];
  var prec = $('[data-pf-prec]'), suiv = $('[data-pf-suiv]');
  var points = $$('.p26-pf-galerie__points span');
  var vignettes = $$('[data-pf-vignette]');
  var courante = 0;

  function allerA(i) {
    if (!piste || !photos[i]) return;
    piste.scrollTo({ left: photos[i].offsetLeft - piste.offsetLeft, behavior: calme ? 'auto' : 'smooth' });
  }
  function majGalerie() {
    if (!piste || !photos.length) return;
    var i = Math.round(piste.scrollLeft / Math.max(piste.clientWidth, 1));
    i = Math.max(0, Math.min(photos.length - 1, i));
    courante = i;
    points.forEach(function (p, k) { p.classList.toggle('est-actif', k === i); });
    vignettes.forEach(function (v, k) { if (k === i) v.setAttribute('aria-current', 'true'); else v.removeAttribute('aria-current'); });
    if (prec) prec.hidden = i === 0;
    if (suiv) suiv.hidden = i === photos.length - 1;
  }
  if (piste) {
    var attente;
    piste.addEventListener('scroll', function () { clearTimeout(attente); attente = setTimeout(majGalerie, 60); }, { passive: true });
    if (prec) prec.addEventListener('click', function () { allerA(courante - 1); });
    if (suiv) suiv.addEventListener('click', function () { allerA(courante + 1); });
    vignettes.forEach(function (v) { v.addEventListener('click', function () { allerA(+v.getAttribute('data-pf-vignette')); }); });
  }

  /* Zoom plein écran */
  var boite = $('[data-pf-zoombox]'), boiteImg = $('[data-pf-zoom-img]'), ouvreurZoom = null;
  $$('[data-pf-zoom]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!boite || typeof boite.showModal !== 'function') return;
      var img = b.querySelector('img');
      boiteImg.src = b.getAttribute('data-pf-zoom');
      boiteImg.alt = img ? img.alt : '';
      ouvreurZoom = b;
      boite.showModal();
      $('[data-pf-fermer]', boite).focus();
    });
  });
  if (boite) {
    $('[data-pf-fermer]', boite).addEventListener('click', function () { boite.close(); });
    boite.addEventListener('click', function (e) { if (e.target === boiteImg) boite.close(); });
    boite.addEventListener('close', function () { if (ouvreurZoom) ouvreurZoom.focus(); });
  }

  /* Variantes */
  var form = document.getElementById('pf-form');
  var donnees = $('[data-pf-variantes]');
  var variantes = [];
  try { variantes = JSON.parse(donnees ? donnees.textContent : '[]'); } catch (e) { variantes = []; }
  var champId = $('[data-pf-id]');
  var groupes = $$('[data-pf-option]');
  var bouton = $('[data-pf-ajout]');
  var boutonBarre = $('[data-pf-barre-btn]');

  function choixActuels() {
    return groupes.map(function (g) { var r = g.querySelector('input:checked'); return r ? r.value : null; });
  }
  function trouver(choix) {
    return variantes.filter(function (v) { return v.options.every(function (o, i) { return o === choix[i]; }); })[0];
  }
  function majEpuises(choix) {
    groupes.forEach(function (g, gi) {
      $$('input[type="radio"]', g).forEach(function (r) {
        var essai = choix.slice(); essai[gi] = r.value;
        var v = trouver(essai);
        var dispo = !!(v && v.available);
        var label = r.nextElementSibling;
        label.classList.toggle('est-epuise', !dispo);
        var sr = label.querySelector('[data-pf-epuise]');
        if (sr) sr.textContent = dispo ? '' : ' (épuisé)';
      });
    });
  }
  function appliquer(v, choix) {
    groupes.forEach(function (g, gi) { var c = g.querySelector('[data-pf-choix]'); if (c) c.textContent = choix[gi]; });
    majEpuises(choix);
    var dispo = !!(v && v.available);
    if (v) {
      champId.value = v.id;
      $('[data-pf-prix]').textContent = v.price;
      var barre = $('[data-pf-barre]');
      if (v.compare) { $('[data-pf-barre-val]').textContent = v.compare; barre.hidden = false; } else { barre.hidden = true; }
      var prixBarre = $('[data-pf-barre-prix]'); if (prixBarre) prixBarre.textContent = v.price;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.media) {
        var i = photos.findIndex(function (p) { return p.getAttribute('data-media') === String(v.media); });
        if (i > -1) allerA(i);
      }
    }
    bouton.disabled = !dispo;
    bouton.textContent = v ? (dispo ? 'Ajouter au panier' : 'Épuisé') : 'Combinaison indisponible';
    if (boutonBarre) boutonBarre.disabled = !dispo;
    $('[data-pf-dispo-texte]').textContent = dispo ? 'Disponible' : 'Épuisé pour le moment';
  }
  groupes.forEach(function (g) {
    g.addEventListener('change', function () { var c = choixActuels(); appliquer(trouver(c), c); });
  });

  /* Quantité */
  var qte = document.getElementById('pf-qte');
  function bornes(n) { return Math.max(1, Math.min(99, n || 1)); }
  var moins = $('[data-pf-moins]'), plus = $('[data-pf-plus]');
  if (moins) moins.addEventListener('click', function () { qte.value = bornes(+qte.value - 1); });
  if (plus) plus.addEventListener('click', function () { qte.value = bornes(+qte.value + 1); });
  if (qte) qte.addEventListener('change', function () { qte.value = bornes(parseInt(qte.value, 10)); });

  /* Panier */
  var annonce = $('[data-pf-annonce]'), erreur = $('[data-pf-erreur]');
  var volet = $('[data-pf-volet]'), ouvreurVolet = null;
  // Le volet est modal : tant qu'il est ouvert, les messages s'affichent dedans (le reste de la page est inerte).
  function dire(msg) {
    var cible = volet && volet.open ? $('[data-pf-volet-annonce]', volet) : annonce;
    cible.textContent = '';
    setTimeout(function () { cible.textContent = msg; }, 50);
  }
  function signaler(msg) {
    var cible = volet && volet.open ? $('[data-pf-volet-erreur]', volet) : erreur;
    cible.textContent = msg;
    cible.hidden = false;
  }
  function majCompteur() {
    return fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var pastille = document.querySelector('.p26-pastille');
      if (pastille) { pastille.textContent = c.item_count; pastille.hidden = false; }
      var ouvreur = document.querySelector('[data-ouvre="minipanier"]');
      if (ouvreur) ouvreur.setAttribute('aria-label', 'Panier, ' + c.item_count + ' article' + (c.item_count > 1 ? 's' : ''));
      if (window.pd26PanierBarre) window.pd26PanierBarre(c);
    }).catch(function () {});
  }
  function ajouter(id, quantite) {
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: quantite }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Ajout impossible.'); return j; });
    });
  }
  function voler() {
    if (calme || !photos[courante]) return;
    var src = photos[courante].querySelector('img');
    var cible = document.querySelector('[data-ouvre="minipanier"]');
    if (!src || !cible || !src.animate) return;
    var a = src.getBoundingClientRect(), b = cible.getBoundingClientRect();
    if (!b.width) return;
    var c = document.createElement('img');
    c.src = src.currentSrc || src.src; c.alt = ''; c.className = 'p26-pf-vol';
    var t = Math.min(a.width, 160);
    c.style.width = c.style.height = t + 'px';
    c.style.left = (a.left + a.width / 2 - t / 2) + 'px'; c.style.top = (a.top + a.height / 2 - t / 2) + 'px';
    racine.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: .4 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.75,0)' }).onfinish = function () { c.remove(); };
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (bouton.disabled) return;
      erreur.hidden = true;
      ouvreurVolet = document.activeElement === boutonBarre ? boutonBarre : bouton;
      bouton.classList.add('est-en-cours');
      bouton.setAttribute('aria-busy', 'true');
      ajouter(champId.value, bornes(+qte.value)).then(function (j) {
        if (volet && typeof volet.showModal === 'function') ouvrirVolet(j && j.items && j.items[0]);
        else { voler(); dire('Ajouté au panier.'); }
        return majCompteur();
      }).catch(function (err) {
        signaler(err.message || 'Ajout impossible. Réessayez ou écrivez-nous.');
      }).then(function () {
        bouton.classList.remove('est-en-cours');
        bouton.removeAttribute('aria-busy');
      });
    });
  }

  /* Volet « Ajouté au panier / Et avec ça ? » */
  function euros(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); }
  function ouvrirVolet(article) {
    if (article) {
      var detail = $('[data-pf-volet-detail]', volet), prix = $('[data-pf-volet-prix]', volet), img = $('[data-pf-volet-img]', volet);
      detail.textContent = (article.variant_title ? article.variant_title + ' · ' : '') + 'Quantité : ' + article.quantity;
      prix.textContent = euros(article.final_line_price);
      if (article.image) img.src = article.image + (article.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    $('[data-pf-volet-erreur]', volet).hidden = true;
    volet.showModal();
    $('#pf-volet-titre', volet).focus();
  }
  if (volet) {
    $$('[data-pf-volet-fermer]', volet).forEach(function (b) { b.addEventListener('click', function () { volet.close(); }); });
    volet.addEventListener('click', function (e) { if (e.target === volet) volet.close(); });
    volet.addEventListener('close', function () { if (ouvreurVolet && !ouvreurVolet.closest('[hidden]')) ouvreurVolet.focus(); else if (bouton) bouton.focus(); });
    $$('[data-pf-volet-ajout]', volet).forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        ajouter(b.getAttribute('data-pf-volet-ajout'), 1).then(function () {
          b.textContent = '✓ Ajouté';
          b.classList.add('est-ajoute');
          dire('Ajouté au panier.');
          return majCompteur();
        }).catch(function (err) {
          b.disabled = false;
          signaler(err.message || 'Ajout impossible.');
        });
      });
    });
  }

  /* Ampoules : choix de la lumière, ajout direct */
  $$('[data-pf-amp]').forEach(function (bloc) {
    var choix = $$('[data-pf-lumiere]', bloc), cartes = $$('[data-pf-amp-carte]', bloc);
    choix.forEach(function (b) {
      b.addEventListener('click', function () {
        var l = b.getAttribute('data-pf-lumiere');
        choix.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cartes.forEach(function (c) { c.hidden = c.getAttribute('data-pf-amp-carte') !== l; });
      });
    });
    $$('[data-pf-amp-ajout]', bloc).forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        ajouter(b.getAttribute('data-pf-amp-ajout'), 1).then(function () {
          b.textContent = 'Ampoule ajoutée';
          dire('Ampoule ajoutée au panier.');
          return majCompteur();
        }).catch(function (err) {
          b.disabled = false;
          signaler(err.message || 'Ajout impossible.');
        });
      });
    });
  });

  /* Barre d'achat collante (mobile) : visible quand le vrai bouton sort de l'écran */
  var barreCollante = $('[data-pf-barre-collante]');
  if (barreCollante && bouton && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entrees) {
      var e = entrees[0];
      barreCollante.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    });
    io.observe(bouton);
    boutonBarre.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else bouton.click();
    });
  }

  /* « Poser une question » : ouvre le panneau d'aide du socle directement sur le champ de question,
     prérempli avec le nom du produit (valeur de data-poser-question) */
  $$('[data-poser-question]', document).forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.querySelector('.p26-torche'), a = document.getElementById('aide');
      if (!t || !a) return;
      if (a.hidden) t.click();
      var champ = document.getElementById('p26-aide-q');
      if (!champ) return;
      var nom = b.getAttribute('data-poser-question');
      if (nom && !champ.value) champ.value = 'À propos de « ' + nom + ' » : ';
      setTimeout(function () {
        champ.focus();
        champ.setSelectionRange(champ.value.length, champ.value.length);
        champ.scrollIntoView({ block: 'nearest' });
      }, 0);
    });
  });

  majGalerie();
  if (groupes.length) majEpuises(choixActuels());
})();
